import { useEffect, useRef, useState } from "react";
import { subscribeActiveNews } from "../../../services/commercialNewsService";
import transliterate from "../../../function/transliterate";
import { Link, useNavigate } from "react-router-dom";
import "../../mainPage/mainPage.css"; // використовуємо ваші стилі (yellow/blue блоки, стрілки тощо)
import { HandySvg } from "handy-svg";
import iconSrc from "../../../svg/arrowLeft.svg";
import arrow from "../../../svg/arrow.svg";

export default function CommercialNewsBanner() {
  const [items, setItems] = useState([]);
  const [idx, setIdx] = useState(0);
  const navigate = useNavigate();
  const startX = useRef(null);
  const endX = useRef(null);
  const dragging = useRef(false);

  useEffect(() => {
    const unsub = subscribeActiveNews(setItems);
    return () => unsub && unsub();
  }, []);

  const current = items[idx] || null;

  const next = () => setIdx((i) => (i < items.length - 1 ? i + 1 : 0));
  const prev = () => setIdx((i) => (i > 0 ? i - 1 : items.length - 1));

  // свайпи
  const onTouchStart = (e) => (startX.current = e.touches[0].clientX);
  const onTouchMove = (e) => (endX.current = e.touches[0].clientX);
  const onTouchEnd = () => {
    if (startX.current && endX.current) {
      const d = startX.current - endX.current;
      if (d > 50) next();
      else if (d < -50) prev();
    }
    startX.current = endX.current = null;
  };
  const onMouseDown = (e) => {
    startX.current = e.clientX;
    dragging.current = true;
  };
  const onMouseMove = (e) => {
    if (dragging.current) endX.current = e.clientX;
  };
  const onMouseUp = () => {
    if (startX.current && endX.current) {
      const d = startX.current - endX.current;
      if (d > 50) next();
      else if (d < -50) prev();
    }
    startX.current = endX.current = null;
    dragging.current = false;
  };

  if (!current) return null;

  const productSlug =
    current?.linkedProduct?.slug ||
    (current?.linkedProduct?.bookName
      ? transliterate(current.linkedProduct.bookName)
      : "");

  const toProduct = `/product/${productSlug}`;
  console.log("Компонента відобразилась");

  return (
    <div
      className="newBooksWrapBlock" // використовуємо існуючу розмітку для стилю банера
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      onMouseDown={onMouseDown}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
    >
      <div className="yellowBorderWrap">
        <div className="imgPictureBox">
          <img
            src={current.imageUrl}
            alt={current.imageAlt || current.title || "Новина"}
            className="productBigPictureImg"
          />
          {/* <div className="markerNew">Комерційна новина</div> */}
        </div>

        <HandySvg
          onClick={prev}
          className="arrowLeft"
          src={iconSrc}
          width="42"
          height="40"
        />
      </div>

      <div className="blueBorderWrap">
        <div className="infoPredProdagNewBooks">
          <h1 className="nameBooksNewBooks" style={{ cursor: "default" }}>
            Комерційні новини
          </h1>

          <Link to={toProduct} className="nameBooksNew">
            {current.title}
          </Link>

          {current.subtitle && (
            <p className="descriptionBooksNew">{current.subtitle}</p>
          )}

          <div className="blockOrderBooksWrap">
            <div className="prodPricLikeCartNovun">
              {/* можна використати ціну/теги, але тут — CTA */}
              <button
                className="likeProductSmallSaleNovu"
                onClick={() => navigate(toProduct)}
                style={{
                  border: "none",
                  background: "#3e51c1",
                  color: "#fff",
                  borderRadius: 0,
                  width: "auto",
                  height: "auto",
                  padding: "14px 20px",
                  cursor: "pointer",
                }}
              >
                {current.ctaText || "Детальніше"}
              </button>
            </div>

            <HandySvg
              onClick={next}
              src={arrow}
              className="arrovIconBanner"
              width="52"
              height="49.56"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
